export const LOGIN = '/login';
export const SIGN_UP = '/signup';
export const FORGET_PASSWORD = '/forget-password';
export const PROFILE = '/profile';
export const EDIT_PROFILE = '/edit-profile';
export const CHANGE_PASSWORD = '/change-password';

export const DASHBOARD_PAGE = '/';
export const TRADE_HISTORY_PAGE = '/trade-history';
export const STOCKS_PAGE = '/stocks';
export const STOCKS_DETAILS = '/stocks/:id';
export const TRADING_CALENDAR_PAGE = '/calendar';
export const TRADERS_PAGE = '/traders';
export const STRATEGY_PAGE = '/strategy';
export const TECHNICAL_ANALYSIS_PAGE = '/technical-analysis';
export const PERFORMANCE_PAGE = '/performance-matrics';
export const REPORTS_PAGE = '/reports';
export const SETTING_PAGE = '/setting';

export const ALL = '*';
